module.exports = __webpack_public_path__ + "img/security.5a35dbda.svg";